import React, { useState } from 'react';
import { Row, Col, Button, Dropdown, Form } from 'react-bootstrap';
import './AdminProfessionalInfo.css';
import Swal from 'sweetalert2';

function AdminLatheMachineFields({ formData, setFormData }) {
    const [skillDropdownOpen, setSkillDropdownOpen] = useState(false);
    const [skillSearch, setSkillSearch] = useState('');

    const updateField = (field, value) => setFormData(prev => ({ ...prev, [field]: value }));

    const toggleArrayField = (field, item, maxLimit = null) => {
        const currentArray = Array.isArray(formData[field]) ? formData[field] : [];
        if (currentArray.includes(item)) {
            updateField(field, currentArray.filter(i => i !== item));
        } else {
            if (maxLimit && currentArray.length >= maxLimit) {
                Swal.fire({ icon: 'warning', title: 'Limit Reached', text: `You can select a maximum of ${maxLimit} options.`, confirmButtonColor: '#0d6efd' });
                return;
            }
            updateField(field, [...currentArray, item]);
        }
    };

    const latheMachineOptions = ["Manual Lathe", "Heavy Duty Lathe", "CNC Lathe", "Facing & Turning", "Thread Cutting", "Taper Turning", "Knurling"];
    const millingMachineOptions = ["Vertical Milling", "Horizontal Milling", "CNC Milling", "Slot Cutting", "Gear Cutting", "Surface Milling", "Drilling & Boring"];
    const technicalSkillsOptions = ["Blueprint / Drawing Reading", "Measuring Instruments Handling", "Vernier Caliper", "Micrometer", "Dial Gauge", "Surface Finish Checking", "Tool Setting", "Machine Maintenance", "Safety Compliance"];
    const materialOptions = ["Mild Steel", "Stainless Steel", "Aluminum", "Brass", "Cast Iron", "Alloy Steel"];

    const latheMachineKnowledge = Array.isArray(formData.lathe_machine_knowledge) ? formData.lathe_machine_knowledge : [];
    const millingMachineKnowledge = Array.isArray(formData.milling_machine_knowledge) ? formData.milling_machine_knowledge : [];
    const techSkills = Array.isArray(formData.lathe_technical_skills) ? formData.lathe_technical_skills : [];
    const materialExperience = Array.isArray(formData.lathe_material_experience) ? formData.lathe_material_experience : [];
    const filteredSkills = technicalSkillsOptions.filter(s => s.toLowerCase().includes(skillSearch.toLowerCase()));

    const isLatheSelected = Array.isArray(formData.job_position) && (formData.job_position.includes('Lathe Machine Operator') || formData.job_position.includes('Lathe & Milling Machine'));
    const isMillingSelected = Array.isArray(formData.job_position) && (formData.job_position.includes('Milling Machine Operator') || formData.job_position.includes('Lathe & Milling Machine'));

    return (
        <>
            {isLatheSelected && (
                <div className="mb-5">
                    <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Machine Knowledge</h4>
                    <Row className="g-3 mb-3">
                        {latheMachineOptions.map((option, idx) => (
                            <Col xs={6} sm={6} md={4} key={idx}>
                                <Button variant="light" className={`language-btn jobtype-btn w-100 ${latheMachineKnowledge.includes(option) ? 'selected-button' : ''}`} onClick={() => toggleArrayField('lathe_machine_knowledge', option)}>{option}</Button>
                            </Col>
                        ))}
                    </Row>
                </div>
            )}
            {isMillingSelected && (
                <div className="mb-5">
                    <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Machine Knowledge</h4>
                    <Row className="g-3 mb-3">
                        {millingMachineOptions.map((option, idx) => (
                            <Col xs={6} sm={6} md={4} key={idx}>
                                <Button variant="light" className={`language-btn jobtype-btn w-100 ${millingMachineKnowledge.includes(option) ? 'selected-button' : ''}`} onClick={() => toggleArrayField('milling_machine_knowledge', option)}>{option}</Button>
                            </Col>
                        ))}
                    </Row>
                </div>
            )}
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">
                    Technical Skills <span className="ms-2 text-muted" style={{ fontSize: '14px', fontWeight: 'normal' }}>(Max 4 options)</span>
                </h4>
                <Dropdown show={skillDropdownOpen} onToggle={(open) => setSkillDropdownOpen(open)}>
                    <Dropdown.Toggle variant="light" className="language-select w-100 d-flex justify-content-between align-items-center" id="dropdown-admin-lathe-skills">
                        <span style={{ color: techSkills.length > 0 ? '#212529' : '#6c757d' }}>{techSkills.length > 0 ? `Technical Skills (${techSkills.length} selected)` : 'Select Technical Skills'}</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="w-100" style={{ overflowY: 'hidden' }}>
                        <div className="px-2 py-1">
                            <Form.Control type="text" placeholder="Search skills..." value={skillSearch} onChange={(e) => setSkillSearch(e.target.value)} onClick={(e) => e.stopPropagation()} className="mb-2" autoFocus />
                        </div>
                        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                            {filteredSkills.map((skill) => (<Dropdown.Item key={skill} active={techSkills.includes(skill)} onClick={() => toggleArrayField('lathe_technical_skills', skill, 4)}>{skill}</Dropdown.Item>))}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
                {techSkills.length > 0 && (
                    <div className="mt-3 d-flex flex-wrap gap-2">
                        {techSkills.map((skill, idx) => (
                            <div key={idx} className="badge bg-primary d-flex align-items-center" style={{ fontSize: '0.85rem' }}>
                                {skill}<button type="button" className="btn-close btn-close-white ms-2" style={{ fontSize: '0.5rem' }} onClick={() => toggleArrayField('lathe_technical_skills', skill)} aria-label="Remove" />
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Material Experience</h4>
                <Row className="g-3 mb-4">
                    {materialOptions.map((option, idx) => (
                        <Col xs={6} sm={6} md={4} key={idx}>
                            <Button variant="light" className={`language-btn jobtype-btn w-100 ${materialExperience.includes(option) ? 'selected-button' : ''}`} onClick={() => toggleArrayField('lathe_material_experience', option)}>{option}</Button>
                        </Col>
                    ))}
                </Row>
            </div>
        </>
    );
}

export default AdminLatheMachineFields;
